//? Import Components

//* Errors
import { ErrorPageComponent } from './errors/error-page/error-page.component';
import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component';
import { AddressComponent } from './edit/address/address.component';
import { PersonalComponent } from './edit/personal/personal.component';

//* Personal
import { WizardComponent } from './wizard/wizard.component';

export const components = [
  PersonalComponent,
  ErrorPageComponent,
  PageNotFoundComponent,
  AddressComponent,
  WizardComponent,
];

export const services: any[] = [];

//? Export Components
//* Errors
export * from './errors/error-page/error-page.component';
export * from './errors/page-not-found/page-not-found.component';

// forms
export * from './edit/address/address.component';
export * from './edit/personal/personal.component';

//Export Services
